import { Container } from "./styles";

export function TimeLineRoot({ children }) {
  return <Container>{children}</Container>;
}
